import { Formik } from 'formik';
import React, { useState, useEffect } from 'react';
import { FormPermintaanAsetContent } from './__PermintaanAsetComps__';
import { useMutation, useQuery } from 'react-query';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import MaintenanceRequestApi from './__PermintaanAsetApi__';
import {
  formInitialValues,
  formSubmitValueMapper,
  formValidationSchema,
} from './__PermintaanAsetUtils__';
import { Alert, DataStatus } from 'components';

export const PermintaanAsetDetail = ({ setNavbarTitle }) => {
  const history = useHistory();
  const { id } = useParams();

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: '',
    variant: 'primary',
  });

  const {
    data: detailPermintaanAset,
    isFetching: loadingDetailPermintaanAset,
  } = useQuery(
    ['permintaanAset', 'single', id],
    () =>
      MaintenanceRequestApi.getSingle({
        id_permintaan_aset: id,
      }),
    { enabled: !!id }
  );

  const createMaintenanceRequest = useMutation((data) =>
    MaintenanceRequestApi.update(data)
  );
  const formSubmitHandler = (value) => {
    createMaintenanceRequest
      .mutateAsync(formSubmitValueMapper(value))
      .then(() =>
        history.push('/transaksi/maintenance-request', {
          alert: {
            variant: 'primary',
            show: true,
            text: 'Data berhasil disimpan!!!',
          },
        })
      )
      .catch((err) =>
        setAlertConfig({
          variant: 'danger',
          show: true,
          text: 'Data gagal disimpan!!!',
        })
      );
  };

  useEffect(() => {
    setNavbarTitle('Maintenance Request');

    return () => {};
  }, []);

  return (
    <>
      <Alert
        show={alertConfig?.show}
        text={alertConfig?.text}
        variant={alertConfig?.variant}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
        showCloseButton
      />
      {loadingDetailPermintaanAset ? (
        <DataStatus loading text="Memuat Data..." />
      ) : (
        <Formik
          initialValues={formInitialValues(detailPermintaanAset?.data)}
          onSubmit={formSubmitHandler}
          validationSchema={formValidationSchema}
        >
          <FormPermintaanAsetContent action="detail" />
        </Formik>
      )}
    </>
  );
};
